import { render } from "./Logo.vue?vue&type=template&id=3c0611a8&scoped=true&ts=true"
import script from "./Logo.vue?vue&type=script&lang=ts"
export * from "./Logo.vue?vue&type=script&lang=ts"

import "./Logo.vue?vue&type=style&index=0&id=3c0611a8&lang=less&scoped=true"

import exportComponent from "/Users/agtalpai/Munka/hba/hba-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0611a8"]])

export default __exports__